import axios from '@/library/modules/axios.js'
export function fromBaseApis(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/hospitals',
    method: 'post',
    data
  })
}
export function regionaQuery(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/regions/query',
    method: 'post',
    data
  })
}
export function getHosDict(params) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/dict/labels',
    method: 'get',
    params
  })
}

// 获取院区列表
export function getHospitalAreaList(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/hospital-areas/query',
    method: 'post',
    data
  })
}

// 根据院区id查询科室数
export function getDepartmentCount(id) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas/${id}/departments/tree`,
    method: 'post'
  })
}
export function getDepartmentCounts(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas/${data.id}/departments/tree?category=${data.category}`,
    method: 'post'
  })
}

// 查询科室列表
export function getHospitalDepartmentsList(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/departments/query',
    method: 'post',
    data
  })
}

//  查询特殊科室树
export function getSpecialDepartmentTree(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/departments/special-tree/query',
    method: 'post',
    data
  })
}
// 搜索医院
export function searchHospital(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/search/hospital',
    method: 'post',
    data
  })
}
// 查询院区详情
export function getHospitalDetail(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas?hospital_area_id=${data.hospital_area_id ? data.hospital_area_id : ''}&hospital_area_code=${
      data.hospital_area_code ? data.hospital_area_code : ''
    }`,
    method: 'post'
  })
}
// 查询院区详情 - 埋点用
export function getHospitalDetailSetPiont(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas-detail?hospital_area_id=${data.hospital_area_id ? data.hospital_area_id : ''}&hospital_area_code=${
      data.hospital_area_code ? data.hospital_area_code : ''
    }`,
    method: 'post'
  })
}
